var settings;
var freeShippingRegion = "us";
var selectorBody = document.querySelector('body');

function toggleButton() {
    let freeShippingButton = document.getElementById('free-shipp');
    freeShippingButton.classList.toggle("on");
    freeShippingRegion = freeShippingRegion === 'us' ? 'international' : 'us';

    var buttonCheckout = document.querySelectorAll('.buttonCheckout');
    var USShipping = document.querySelector('.free-shipping__region-toggle');
    var containerbuttonCheckout = document.querySelector('.containerbuttonCheckout');

    if (USShipping.classList.contains("on")) {
        containerbuttonCheckout.insertAdjacentHTML('afterbegin', "<a href='/pages/international-checkout' style='display:block;text-decoration: none' class='button tc buttonCheckout button-large b--navy bg-navy white w-100'>Checkout</a>")
        for (var i = 0; i < buttonCheckout.length; ++i) {
            buttonCheckout[i].remove();
        }
    } else {
        containerbuttonCheckout.insertAdjacentHTML('afterbegin', "<a href='/checkout' style='display:block;text-decoration: none' class='button tc buttonCheckout button-large b--navy bg-navy white w-100'>Checkout</a>")
        for (var i = 0; i < buttonCheckout.length; ++i) {
            buttonCheckout[i].remove();
        }
    }

};

